module.exports = __webpack_public_path__ + "img/notes.9234bd5b.png";